import React, { Fragment } from "react";
import styles from "./PersonalData.module.sass";
import theme from "../../../App.module.sass";

import Input from "../../ui/Input/Input";
import TitleSection from "../../TitleSection/TitleSection";
import ExpodedPerson from "../ExposedPerson/ExposedPerson";

import masks from "../../../utils/masks";
import api from "../../../utils/api";
import formatters from "../../../utils/select-formatters";
import { inputType } from "../../ui/Input/Input";
import RadioGroup from "../../../components/ui/RadioGroup/RadioGroup";
import validation from "../../../utils/validation";
import currency from "../../../utils/currency";
import dateUtils from "../../../utils/date";
import Fatca from "../Fatca/Fatca";
import AppContext from "../../../contexts/appContext";

class PersonalData extends React.PureComponent {
  state = {
    nome: "",
    cpf: masks.cpf(this.props.document),
    documento: "",
    emissor: "",
    nascimento: "",
    estadocivil: "",
    estadocivilName: "",
    nacionalidade: "",
    estado: "",
    naturalidade: "",
    acessibilidade: "",
    sexo: "F",
    profissao: "",
    profissaoName: "",
    mae: "",
    renda: "R$ " + currency.numberToCurrency(this.props.income),
    celular: "",
    fixo: "",
    email: "",
    exposed: "N",
    fatca: {
      fatca: "N",
    },
    conjuge: {
      codigo: "",
      nome: "",
      cpf: "",
      documento: "",
      emissor: "",
      nascimento: "",
      estado: "",
      naturalidade: "",
      acessibilidade: "",
      sexo: "F",
      renda: currency.numberToCurrency(this.props.secondaryIncome),
      exposed: "N",
      cotista: false,
      showFields: false,
    },
  };

  static contextType = AppContext;

  ddds = [];
  cotista = this.props.data.origem.cotista;
  person = this.props.data.pessoa;

  onChangeHandler = (value, name) => {
    if ((name === "celular" || name === "fixo") && value.length > 9) {
      const ddd = value.substr(0, 2);
      const dddInfo = this.ddds.find((el) => el.ddd.slice(-2) === ddd);
      if (dddInfo) {
        this.setState({
          [`${name}Details`]: {
            number: value.substr(2),
            ddd: ddd,
            uf: dddInfo.uf,
            city: dddInfo.cidade,
          },
          [name]: value,
        });
        return;
      }
    }
    this.setState({ [name]: value });
  };

  componentDidMount() {
    this.fetchDDDs();

    if (this.context.ibc) {
      this.setState({
        nome: this.context.ibcUser.nome,
        cpf: this.context.ibcUser.cpf,
        documento: this.context.ibcUser.documento,
        emissor: `${this.context.ibcUser.emissorCode}/${this.context.ibcUser.emissorUF}`,
        nascimento: this.context.ibcUser.nascimento,
        estadocivil: this.context.ibcUser.estadocivil,
        estadocivilName: this.context.ibcUser.estadocivilName,
        nacionalidade: this.context.ibcUser.nacionalidade,
        estado: this.context.ibcUser.estado,
        naturalidade: this.context.ibcUser.naturalidade,
        acessibilidade: this.context.ibcUser.acessibilidade,
        sexo:
          this.context.ibcUser.sexo === "" ? "F" : this.context.ibcUser.sexo,
        profissao: "",
        profissaoName: this.context.ibcUser.profissaoName,
        mae: this.context.ibcUser.mae,
        renda: "R$ " + currency.numberToCurrency(this.props.income),
        celular: this.context.ibcUser.celular,
        fixo: this.context.ibcUser.fixo,
        email: this.context.ibcUser.email,
      });
    } else if (this.cotista) {
      this.setState({
        nome: this.person.nome,
        cpf: masks.cpf(this.person.identificacao.codigo),
        documento: this.person.dadosPessoaFisica.documento.codigo,
        emissor: this.person.dadosPessoaFisica.documento.orgaoEmissor,
        nascimento: dateUtils.format(
          new Date(this.person.dadosPessoaFisica.dataNascimento)
        ),
        estadocivil: this.person.dadosPessoaFisica.estadoCivil.codigo,
        estadocivilName: this.person.dadosPessoaFisica.estadoCivil.valor,
        nacionalidade: this.person.dadosPessoaFisica.nacionalidade.valor,
        estado: this.person.endereco.estado,
        naturalidade: this.person.dadosPessoaFisica.naturalidade.valor,
        acessibilidade: `${parseInt(
          this.person.dadosPessoaFisica.acessibilidade.codigo
        )}`,
        sexo: this.person.dadosPessoaFisica.sexo.codigo,
        profissao: `${parseInt(
          this.person.dadosPessoaFisica.profissao.codigo
        )}`,
        profissaoName: this.person.dadosPessoaFisica.profissao.valor,
        mae: this.person.dadosPessoaFisica.filiacao.mae,
        renda: `R$ ${currency.numberToCurrency(
          this.person.dadosPessoaFisica.informacoesEconomicas.faixaRenda[0]
            .valor
        )}`,
        celular: "",
        fixo: "",
        email: "",
      });
    }
  }

  fetchDDDs = () => {
    api.get(api.endpoints.DDD).then((result) => {
      this.ddds = result.data;
      if (this.props.data.pessoa.dadosPessoaFisica || this.context.ibc) {
        let ddd = this.state.fixo.substr(0, 2);
        let dddInfo = this.ddds.find((el) => el.ddd.slice(-2) === ddd);
        if (dddInfo == null) {
          return;
        }
        const fixoDetails = {
          number: this.state.fixo.substr(2),
          ddd: ddd,
          uf: dddInfo.uf,
          city: dddInfo.cidade,
        };
        ddd = this.state.celular.substr(0, 2);
        dddInfo = this.ddds.find((el) => el.ddd.slice(-2) === ddd);
        if (dddInfo == null) {
          return;
        }
        const celularDetails = {
          number: this.state.celular.substr(2),
          ddd: ddd,
          uf: dddInfo.uf,
          city: dddInfo.cidade,
        };
        this.setState({
          fixoDetails,
          celularDetails,
        });
      } else {
        this.forceUpdate();
      }
    });
  };

  onChangeConj = (value, name) => {
    this.setState({ conjuge: { ...this.state.conjuge, [name]: value } });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state !== prevState) {
      this.props.onChange({ ...this.state });
    }
  }

  partnerDataHandler = (cpf) => {
    this.setState({
      conjuge: {
        ...this.state.conjuge,
        cpf: cpf,
      },
    });
  };

  render() {
    return (
      <React.Fragment>
        <section className={styles.sectionForm}>
          <TitleSection title="Seus dados" />

          <div className={styles.formGroup}>
            <div className={theme.row}>
              <Input
                className={theme.col}
                name="nome"
                value={this.state.nome}
                onChange={this.onChangeHandler}
                type="text"
                typeDocument="Nome"
                readonly={this.cotista}
                validationRules={[
                  validation.required,
                  validation.minLength(3),
                  validation.lettersOnly,
                  validation.hasLastName,
                ]}
                maxLength={79}
              />
            </div>
            <div className={theme.row}>
              <Input
                className={theme.col33}
                typeDocument="CPF"
                name="cpf"
                value={masks.cpf(this.props.document)}
                type="text"
                readonly
              />
              <Input
                className={theme.col33}
                typeDocument="RG"
                name="documento"
                value={this.state.documento}
                onChange={this.onChangeHandler}
                type="text"
                readonly={this.cotista}
                mask={masks.numberOnly}
                validationRules={[validation.required]}
                maxLength={30}
              />
              <Input
                className={theme.col33}
                typeDocument="Órgão Emissor"
                name="emissor"
                value={this.state.emissor}
                onChange={this.onChangeHandler}
                type="text"
                readonly={this.cotista}
                validationRules={[validation.required]}
                maxLength={31}
              />
            </div>
            <div className={theme.row}>
              <Input
                className={theme.col33}
                typeDocument="Data de Nascimento"
                name="nascimento"
                value={this.state.nascimento}
                onChange={this.onChangeHandler}
                type="text"
                mask={masks.date}
                maxLength="10"
                readonly={this.cotista}
                validationRules={[validation.required, validation.date]}
              />

              <Input
                className={[theme.dropdown, theme.col33].join(" ")}
                typeDocument="Estado Civil"
                formatter={formatters.selectVal}
                onSelect={(value) => {
                  this.setState({ estadocivil: value.codigo || "" });
                  this.setState({ estadocivilName: value.valor || "" });
                }}
                optionsUrl={api.endpoints.CIVIL_STATE}
                value={this.state.estadocivil}
                type={inputType.AUTOCOMPLETE}
                validationRules={[validation.required]}
                readonly={this.cotista}
              />

              <Input
                className={[theme.dropdown, theme.col33].join(" ")}
                typeDocument="Acessibilidade"
                onSelect={(value) => {
                  this.setState({ acessibilidade: value });
                }}
                optionsUrl={api.endpoints.ACCESSIBILITY}
                formatter={formatters.default}
                value={this.state.acessibilidade}
                type={inputType.AUTOCOMPLETE}
                readonly={this.cotista}
                validationRules={[validation.required]}
              />
            </div>
            <div className={theme.row}>
              <Input
                className={[theme.dropdown, theme.col33].join(" ")}
                typeDocument="Estado"
                onSelect={(value) => {
                  this.setState({ estado: value });
                }}
                optionsUrl={api.endpoints.STATES}
                formatter={formatters.selectState}
                value={this.state.estado}
                type={inputType.AUTOCOMPLETE}
                readonly={this.cotista}
                validationRules={[validation.required]}
              />

              <Input
                className={theme.col33}
                typeDocument="Naturalidade"
                name="naturalidade"
                value={this.state.naturalidade}
                onChange={this.onChangeHandler}
                type="text"
                readonly={this.cotista}
                validationRules={[validation.required, validation.lettersOnly]}
                maxLength={40}
              />
              <Input
                className={[theme.dropdown, theme.col33].join(" ")}
                typeDocument="Nacionalidade"
                onSelect={(value) => {
                  this.setState({ nacionalidade: value });
                }}
                queryKey="pais"
                optionsUrl={api.endpoints.COUNTRY}
                formatter={formatters.default}
                value={this.state.nacionalidade}
                type={inputType.AUTOCOMPLETE}
                readonly={this.cotista}
                validationRules={[validation.required]}
              />
            </div>
            <div className={theme.row}>
              <div className={[theme.radioOptions, theme.col50].join(" ")}>
                <label className={styles.formLabel}>Sexo:</label>
                <RadioGroup
                  options={["Feminino", "Masculino"].map((el) => ({
                    value: el === "Feminino" ? "F" : "M",
                    text: el,
                  }))}
                  value={this.state.sexo}
                  onChanged={(value) => {
                    this.setState({ sexo: value });
                  }}
                  readonly={this.cotista}
                />
              </div>
            </div>

            <div className={theme.row}>
              <Input
                className={[theme.dropdown, theme.col50].join(" ")}
                typeDocument="Profissão"
                onSelect={(value) => {
                  this.setState({ profissao: value.codigo || "" });
                  this.setState({ profissaoName: value.valor || "" });
                }}
                optionsUrl={api.endpoints.PROFESSION}
                queryKey="profissao"
                formatter={formatters.selectVal}
                value={
                  this.cotista ? this.state.profissaoName : this.state.profissao
                }
                type={inputType.AUTOCOMPLETE}
                readonly={this.cotista}
                validationRules={[validation.required]}
                ibcValue={
                  this.context.ibc && this.context.ibcUser.profissaoName
                }
              />
              <Input
                className={theme.col50}
                typeDocument="Renda"
                name="renda"
                value={this.state.renda}
                type="text"
                readonly
                tooltip={
                  this.cotista
                    ? "Quer alterar sua renda? Fale com a gente no chat."
                    : null
                }
              />
            </div>

            <div className={theme.row}>
              <Input
                className={theme.col100}
                typeDocument="Nome da Mãe"
                name="mae"
                value={this.state.mae}
                onChange={this.onChangeHandler}
                type="text"
                readonly={this.cotista}
                validationRules={[
                  validation.required,
                  validation.minLength(3),
                  validation.lettersOnly,
                ]}
                maxLength={51}
              />
            </div>
            <div className={theme.row}>
              <Input
                className={theme.col50}
                typeDocument="Telefone celular"
                name="celular"
                value={this.state.celular}
                onChange={(value, name) => {
                  value = value.substr(0, 11);
                  this.onChangeHandler(value, name);
                }}
                type="text"
                mask={masks.phone}
                maxLength={15}
                validationRules={[
                  validation.required,
                  validation.phone("mobile"),
                  validation.ddd(this.ddds),
                ]}
              />
              <Input
                className={theme.col50}
                typeDocument="Telefone fixo"
                name="fixo"
                value={this.state.fixo}
                onChange={(value, name) => {
                  value = value.substr(0, 11);
                  this.onChangeHandler(value, name);
                }}
                type="text"
                mask={masks.phone}
                maxLength={15}
                validationRules={[
                  validation.phone("landline"),
                  validation.ddd(this.ddds),
                ]}
              />
            </div>
            <div className={theme.row}>
              <Input
                className={theme.col}
                typeDocument="Email"
                name="email"
                value={this.state.email}
                onChange={this.onChangeHandler}
                type="text"
                validationRules={[validation.required, validation.email]}
                maxLength={51}
              />
            </div>
          </div>
        </section>

        {!this.cotista && (
          <section className={styles.sectionForm}>
            <Fatca
              onChange={(fatcaData) => this.setState({ fatca: fatcaData })}
            />
          </section>
        )}

        {!this.cotista && (
          <section className={styles.sectionForm}>
            <ExpodedPerson
              onChange={(value) => {
                this.onChangeHandler(value, "exposed");
              }}
              pf
            />
          </section>
        )}

        {!this.cotista && this.state.estadocivil === "C" && (
          <Fragment>
            <section className={styles.sectionForm}>
              <TitleSection title="Dados do Cônjuge" />
              <div className={styles.formGroup}>
                <div className={theme.row} id="conjugeDoc">
                  <Input
                    className={theme.col33}
                    typeDocument="CPF"
                    name="cpf"
                    value={this.state.conjuge.cpf}
                    onChange={this.partnerDataHandler}
                    type="text"
                    mask={masks.cpf}
                    maxLength="14"
                    validationRules={[validation.required, validation.vCpf]}
                  />
                </div>

                <div className={theme.row}>
                  <Input
                    className={theme.col66}
                    name="nome"
                    value={this.state.conjuge.nome}
                    onChange={this.onChangeConj}
                    type="text"
                    typeDocument="Nome"
                    validationRules={[
                      validation.required,
                      validation.minLength(3),
                      validation.lettersOnly,
                    ]}
                    readonly={this.state.conjuge.cotista}
                    maxLength={79}
                  />
                  <Input
                    className={theme.col33}
                    typeDocument="RG"
                    name="documento"
                    value={this.state.conjuge.documento}
                    onChange={this.onChangeConj}
                    type="text"
                    validationRules={[validation.required]}
                    readonly={this.state.conjuge.cotista}
                    maxLength={30}
                  />
                </div>

                <div className={theme.row}>
                  <Input
                    className={theme.col33}
                    typeDocument="Órgão emissor"
                    name="emissor"
                    value={this.state.conjuge.emissor}
                    onChange={this.onChangeConj}
                    type="text"
                    validationRules={[validation.required]}
                    readonly={this.state.conjuge.cotista}
                    maxLength={31}
                  />
                  <Input
                    className={theme.col33}
                    typeDocument="Data de Nascimento"
                    name="nascimento"
                    value={this.state.conjuge.nascimento}
                    onChange={this.onChangeConj}
                    type="text"
                    mask={masks.date}
                    maxLength="10"
                    validationRules={[validation.required, validation.date]}
                    readonly={this.state.conjuge.cotista}
                  />

                  <Input
                    className={[theme.dropdown, theme.col33].join(" ")}
                    typeDocument="Estado"
                    onSelect={(value) => {
                      this.setState({
                        conjuge: { ...this.state.conjuge, estado: value },
                      });
                    }}
                    optionsUrl={api.endpoints.STATES}
                    formatter={formatters.selectState}
                    value={this.state.conjuge.estado}
                    type={inputType.AUTOCOMPLETE}
                    readonly={this.state.conjuge.cotista}
                    validationRules={[validation.required]}
                  />
                </div>
                <div className={theme.row}>
                  <Input
                    className={theme.col33}
                    typeDocument="Naturalidade"
                    name="naturalidade"
                    value={this.state.conjuge.naturalidade}
                    onChange={this.onChangeConj}
                    type="text"
                    validationRules={[validation.required]}
                    readonly={this.state.conjuge.cotista}
                    maxLength={40}
                  />
                  <Input
                    className={[theme.dropdown, theme.col33].join(" ")}
                    typeDocument="Acessibilidade"
                    onSelect={(value) => {
                      this.setState({
                        conjuge: {
                          ...this.state.conjuge,
                          acessibilidade: value,
                        },
                      });
                    }}
                    optionsUrl={api.endpoints.ACCESSIBILITY}
                    formatter={formatters.default}
                    value={this.state.conjuge.acessibilidade}
                    type={inputType.AUTOCOMPLETE}
                    validationRules={[validation.required]}
                    readonly={this.state.conjuge.cotista}
                  />
                  <Input
                    className={theme.col33}
                    typeDocument="Renda"
                    name="renda"
                    value={this.state.conjuge.renda}
                    onChange={this.onChangeConj}
                    type="text"
                    maxLength={18}
                    mask={masks.currency}
                    validationRules={[validation.required]}
                    readonly={this.state.conjuge.cotista}
                  />
                </div>
                <div className={theme.row}>
                  <div className={[theme.col, theme.radioOptions].join(" ")}>
                    <label className={styles.formLabel}>Sexo:</label>
                    <RadioGroup
                      options={["Feminino", "Masculino"].map((el) => ({
                        value: el === "Feminino" ? "F" : "M",
                        text: el,
                      }))}
                      value={this.state.conjuge.sexo}
                      onChanged={(value) => {
                        this.setState({
                          conjuge: { ...this.state.conjuge, sexo: value },
                        });
                      }}
                      readonly={this.state.conjuge.cotista}
                    />
                  </div>
                </div>
              </div>
            </section>
            {this.state.conjuge.showFields && !this.state.conjuge.cotista && (
              <section className={styles.sectionForm}>
                <ExpodedPerson
                  onChange={(value) => {
                    this.onChangeConj(value, "exposed");
                  }}
                  pf
                  cj
                />
              </section>
            )}
          </Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default PersonalData;
